import { Component, OnInit } from '@angular/core';
import { PathNameService } from 'src/app/services/pathName/path-name.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor(private pathNameService:PathNameService) { }

  ngOnInit(): void {
  }
  setUrl(route:string){
    this.pathNameService.setUrl(route);
  }

}
